/** Data pura no formato `yyyy-mm-dd` (ex: `2026-10-11`), sem horário nem fuso. */
export type IsoDate = string;

const BRASILIA_TIME_ZONE = 'America/Sao_Paulo';

const brasiliaDateFormat = new Intl.DateTimeFormat('en-US', {
  timeZone: BRASILIA_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

/** Data atual no horário de Brasília, independente do fuso do dispositivo. */
export function todayInBrasilia(): IsoDate {
  const parts = brasiliaDateFormat.formatToParts(new Date());
  const part = (type: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === type)?.value ?? '';
  return `${part('year')}-${part('month')}-${part('day')}`;
}

/** `monthIndex` é 0-based (janeiro = 0), como em `Date`. */
export function toIsoDate(year: number, monthIndex: number, day: number): IsoDate {
  return `${year}-${String(monthIndex + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

export function parseIsoDate(date: IsoDate): { year: number; monthIndex: number; day: number } {
  const [year, month, day] = date.split('-').map(Number);
  return { year, monthIndex: month - 1, day };
}

/** `dd/mm/yyyy`, para exibição. */
export function formatIsoDateBr(date: IsoDate): string {
  const [year, month, day] = date.split('-');
  return `${day}/${month}/${year}`;
}
